import type {BioIconProps} from '../../icons/common-types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

export default function TopReviewedProductsLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg {...attributes} width="26" height="14" viewBox="0 0 26 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1102_4181)">
          <path
            d="M16.3454 13.6324C21.1554 13.6001 25.0198 7.07926 25.0198 7.07926C25.0198 7.07464 21.0777 0.600072 16.2632 0.632445C11.4532 0.664818 0.0197754 7.2365 0.0197754 7.2365C0.0197754 7.2365 11.5354 13.6648 16.3454 13.6324Z"
            fill="#3FA9F5"
          />
          <path
            d="M15.6237 11.9167C18.2902 11.9167 20.4519 9.72816 20.4519 7.02843C20.4519 4.3287 18.2902 2.14014 15.6237 2.14014C12.9571 2.14014 10.7954 4.3287 10.7954 7.02843C10.7954 9.72816 12.9571 11.9167 15.6237 11.9167Z"
            fill="white"
          />
          <path d="M12.7367 7.19961L15.1166 9.11424L18.3689 4.98901" fill="white" />
          <path
            d="M12.7367 7.19961L15.1166 9.11424L18.3689 4.98901"
            stroke="#3FA9F5"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </g>
        <defs>
          <clipPath id="clip0_1102_4181">
            <rect width="25" height="13" fill="white" transform="translate(0.0197754 0.632568)" />
          </clipPath>
        </defs>
      </svg>

      <span>Top Reviewed Products</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
